import { App } from 'vue'
import Vue3TouchEvents from 'vue3-touch-events'

export default {
  install(app: App<Element>): any {
    app.use(Vue3TouchEvents)
  }
}
